/* tslint:disable */
/* eslint-disable */
/**
 * Onibi Portal Api
 * The API for the OnibiPortal Server project
 *
 * OpenAPI spec version: v1
 * Contact: info@yumebau.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import globalAxios, { AxiosResponse, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { PlatformTransactionInfoPagedResponse } from '../models';
import { StorePlatform } from '../models';
/**
 * StoreTransactionsApi - axios parameter creator
 * @export
 */
export const StoreTransactionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {Date} [time] 
         * @param {StorePlatform} [platform] 
         * @param {boolean} [isSandbox] 
         * @param {string} [search] 
         * @param {number} [page] 
         * @param {number} [itemsPerPage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStoreTransactionsPlatformPurchaseReportGet: async (time?: Date, platform?: StorePlatform, isSandbox?: boolean, search?: string, page?: number, itemsPerPage?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/StoreTransactions/platformPurchaseReport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (time !== undefined) {
                localVarQueryParameter['time'] = (time as any instanceof Date) ?
                    (time as any).toISOString() :
                    time;
            }

            if (platform !== undefined) {
                localVarQueryParameter['platform'] = platform;
            }

            if (isSandbox !== undefined) {
                localVarQueryParameter['isSandbox'] = isSandbox;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StoreTransactionsApi - functional programming interface
 * @export
 */
export const StoreTransactionsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {Date} [time] 
         * @param {StorePlatform} [platform] 
         * @param {boolean} [isSandbox] 
         * @param {string} [search] 
         * @param {number} [page] 
         * @param {number} [itemsPerPage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStoreTransactionsPlatformPurchaseReportGet(time?: Date, platform?: StorePlatform, isSandbox?: boolean, search?: string, page?: number, itemsPerPage?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<PlatformTransactionInfoPagedResponse>>> {
            const localVarAxiosArgs = await StoreTransactionsApiAxiosParamCreator(configuration).apiStoreTransactionsPlatformPurchaseReportGet(time, platform, isSandbox, search, page, itemsPerPage, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * StoreTransactionsApi - factory interface
 * @export
 */
export const StoreTransactionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {Date} [time] 
         * @param {StorePlatform} [platform] 
         * @param {boolean} [isSandbox] 
         * @param {string} [search] 
         * @param {number} [page] 
         * @param {number} [itemsPerPage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStoreTransactionsPlatformPurchaseReportGet(time?: Date, platform?: StorePlatform, isSandbox?: boolean, search?: string, page?: number, itemsPerPage?: number, options?: AxiosRequestConfig): Promise<AxiosResponse<PlatformTransactionInfoPagedResponse>> {
            return StoreTransactionsApiFp(configuration).apiStoreTransactionsPlatformPurchaseReportGet(time, platform, isSandbox, search, page, itemsPerPage, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StoreTransactionsApi - object-oriented interface
 * @export
 * @class StoreTransactionsApi
 * @extends {BaseAPI}
 */
export class StoreTransactionsApi extends BaseAPI {
    /**
     * 
     * @param {Date} [time] 
     * @param {StorePlatform} [platform] 
     * @param {boolean} [isSandbox] 
     * @param {string} [search] 
     * @param {number} [page] 
     * @param {number} [itemsPerPage] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreTransactionsApi
     */
    public async apiStoreTransactionsPlatformPurchaseReportGet(time?: Date, platform?: StorePlatform, isSandbox?: boolean, search?: string, page?: number, itemsPerPage?: number, options?: AxiosRequestConfig) : Promise<AxiosResponse<PlatformTransactionInfoPagedResponse>> {
        return StoreTransactionsApiFp(this.configuration).apiStoreTransactionsPlatformPurchaseReportGet(time, platform, isSandbox, search, page, itemsPerPage, options).then((request) => request(this.axios, this.basePath));
    }
}
